/**
 * Create legend for mixed error types
 * @param {object} counts - Error counts
 * @returns {HTMLElement|null} Legend element or null
 */
export function createPopupLegend(counts) {
  if (counts.fixable > 0 && counts.informational > 0) {
    // Compose legend HTML
    const legendHtml = `
      <div class="spellcheck-popup-legend">
        <div class="legend-item">
          <span class="legend-dot fixable">●</span> Correggibile automaticamente
        </div>
        <div class="legend-item">
          <span class="legend-dot informational">●</span> Solo informativo
        </div>
      </div>
    `;

    // Create container and set innerHTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = legendHtml;
    return tempDiv.firstElementChild;
  }

  return null;
}
